export default function ensurePath(obj, keys) {
  return keys.reduce((acc, key) => {
    if (acc[key] === undefined) {
      acc[key] = {}
    }
    return acc[key]
  }, obj)
}
